import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import { AuthService } from '../auth.service';
import { ExcelService } from '../excel.service';
import { HandlerService } from '../handler.service';
import { MatTableDataSource } from '@angular/material/table';
import { objectify } from 'tslint/lib/utils';

@Component({
  selector: 'app-manage-brands',
  templateUrl: './manage-brands.component.html',
  styleUrls: ['./manage-brands.component.scss'],
})
export class ManageBrandsComponent {
    displayedColumns = ['name','code','description','category','delete'];
    applyFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.dataSource.filter = filterValue;
    } 
    dataSource: any; 
    cardView;
    excelData: any = [];
    items:any;
    loader: boolean = false;
    fontStyle;
    search:any=[];
    editId;
    category;
    cateName;
    cateId;
  
    constructor(public service: ApiService,
      public router: Router,
      public handler: HandlerService,
      public auth: AuthService,
      public app: AppComponent,
      private bottomSheet: MatBottomSheet,
      public translate: TranslateService,
      public santinzer: DomSanitizer,
      private excelService: ExcelService,
      private platform: Platform) { }
  
  
      ionViewWillEnter(){
        this.fontStyle=localStorage.getItem('lang');
        if (this.platform.ANDROID || this.platform.IOS) {
          this.cardView = 'true';
        }
        else{
          if(localStorage.getItem('config')){
            var con = JSON.parse(localStorage.getItem('config'));
            let y = con.find(res => res.shortCdConst == "DFLTCARDLYT");
            if(y){
              this.cardView=y.userValue;
            }
            else{
              this.cardView = 'true';
            }
           
          }
        }
        this.loader = true;
        this.getCategory();    
      }
      getBrands(){
        this.service.getAllbrand().subscribe((res:any) => {
          this.loader = false;
          if (res) {
            this.items = res;
            this.items.map(dat=>{
              this.category.map(dat1 => {
                if (dat1.id == dat.purchaseCategory) {
                  Object.assign(dat, { cateName: dat1.name })
                }
            })
              })
        
            this.dataSource = new MatTableDataSource(this.items);

          }
          else {
            this.handler.res("No Agreements For you")
          }
          
        }, err => {
          this.handler.err(err);
          this.loader = false;
        })
      }
      edit(id){
        this.router.navigate(['edit-brands/',id]);
      }
      deletebrand(id){
        this.loader=true;
        this.service.deleteBrand(id).subscribe(res=>{
          this.ionViewWillEnter()
         this.loader=false;
          this.handler.res("Deleted successfully")
          // this.cardView='false';
        },
        err=>{
          this.handler.err(err)
          this.loader=false
        })
      }
      viewChange(id) {
        if (id == 1) { this.cardView = 'true'; }
        else {this.cardView = 'false'; }
      }
      exportAsXLSX(): void {
        this.items.map(res => {
          this.excelData.push({
            Name: res.name, Code: res.code, Description: res.description,Category:res.cateName
          })
        })
        this.excelService.exportAsExcelFile(this.excelData, 'Brand');
      }
      ionViewWillLeave(){
        this.search = "";
      }
      clear(){
        this.search="";
      }

      
getCategory(){
  this.service.getAllPurchaseCategory().subscribe((res:any)=>{
    this.category=res;
    this.getBrands();
   })
}

  }
  

